<template>
  <div class="compare-groups">
    <SubHeader />

    <HeadingWithDescription
      class="compare-groups__heading"
      :size-heading="32"
      :text-heading="textHeading"
      :text-description="textDescription"
    />

    <div class="compare-groups__select-group">
      <CompareGroupsSelector
        @onEnableShowChartTabs="onEnableShowChartTabs"
        @onHasComparison="onHasComparison"
        @onCompareGroupsClick="onCompareGroupsClick"
      />
    </div>

    <hr>

    <div class="compare-groups__body">
      <div
        v-if="showChartTabs"
        class="compare-groups__body-container"
      >
        <BenchmarksTabs :key-followers-by-channel="keyFollowersByChannel" />
      </div>

      <CTAMessage v-if="!hasComparison" />
    </div>
  </div>
</template>

<script>
import { getUrlParameter, MAX_NUMBER_OF_GROUPS, dispatchMixpanelTrack } from '@/utils';
import { insertAppcuesPlugin } from '@/plugins/appcues.js';

import { CTAMessage } from '@/components/base';
import { SubHeader } from '@/components/content/SubHeader';
import { HeadingWithDescription } from '@/components/content/HeadingWithDescription';
import { BenchmarksTabs } from '@/components/content/Tabs';
import { CompareGroupsSelector } from '@/components/content/CompareGroupsSelector';

export default {
  name: 'CompareGroups',
  components: {
    SubHeader,
    CTAMessage,
    HeadingWithDescription,
    BenchmarksTabs,
    CompareGroupsSelector,
  },
  data() {
    return {
      keyFollowersByChannel: 0,
      hasComparison: false,
      showChartTabs: false,
      textHeading: this.$t('Benchmarks.pages.compare.title'),
      textDescription: this.$t('Benchmarks.pages.compare.subTitle', { maxNumberOfGroups: MAX_NUMBER_OF_GROUPS }),
    };
  },
  async mounted() {
    insertAppcuesPlugin({
      user: this.$store.state.user.user,
      user_id: this.$store.state.user.user.id,
      benchmarks: true,
      plan_id: getUrlParameter('plan_id'),
      benchmarks_id: getUrlParameter('benchmarks_id'),
    });

    this.trackSessionView();
    await this.startBenchmarks();
  },
  methods: {
    trackSessionView() {
      dispatchMixpanelTrack('BM Benchmark Session View', ['email', 'groups'], {
        answer: this.$store.state.ui.groupList.length,
      });
    },
    forceFollowersByChannelReMount() {
      this.keyFollowersByChannel += 1;
    },
    dispatchActionsByTabName() {
      const tabsActions = {
        'Base de fãs': () => {
          this.forceFollowersByChannelReMount();
          this.$store.dispatch('tabs/dispatchActionsOnFanBaseTab');
        },
        'Publicações': () => {
          this.$store.dispatch('tabs/dispatchActionsOnPublicationsTab');
        },
        'Interações': () => {
          this.$store.dispatch('tabs/dispatchActionsOnInteractionsTab');
        },
        'Sentimentos': () => {
          this.$store.dispatch('tabs/dispatchActionsOnSentimentsTab');
        },
      };

      const activeTabName = this.$store.state.ui.tabName;

      return activeTabName in tabsActions ? tabsActions[activeTabName]() : null;
    },
    clearPeriods() {
      const periodsActionName = [
        'addFanbaseEvolutionPeriod',
        'addInteractionsOverTimePeriod',
        'addEngagementOverTimePeriod',
        'addPublicationsOverTimeWithDistributionPeriod',
      ];

      periodsActionName.forEach(name => {
        this.$store.dispatch(`charts/${name}`, '');
      });
    },
    onCompareGroupsClick() {
      this.clearPeriods();
      this.dispatchActionsByTabName();
    },
    onEnableShowChartTabs(value) {
      this.showChartTabs = value;
    },
    onHasComparison(value) {
      this.hasComparison = value;
    },
    async startBenchmarks() {
      try {
        const activeCompany = this.$store.state.company.activeCompany;

        await this.$store.dispatch('benchmarks/startBenchmarks', { activeCompany });
      } catch (err) {
        this.$router.push({
          name: 'access-denied',
          params: { errorStatus: '500' },
        });

        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.compare-groups {
  width: 100%;

  hr {
    margin: 31px 0;
    border: 1px solid var(--ds-color-overlay);
  }

  &__heading,
  &__select-group {
    padding: 0 60px;
  }

  &__heading {
    margin-top: 70px;
    margin-bottom: var(--ds-spacing-stack-md);
  }

  &__body {
    &-container {
      padding: 0 60px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
}

::v-deep {
  .ds-button--primary:disabled {
    cursor: not-allowed;
  }
}
</style>
